import React, { Fragment, useState } from 'react';
import { RestHelper } from '../../helper/restHelper';

const AdminEditStatus = (props) => {

    const [showResponseMessage, setShowResponseMessage] = useState(false)
    const [responseMessage, setResponseMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [showOptions, setShowOptions] = useState(true)

    const api = RestHelper()

    function setResponse(res) {
        setResponseMessage(res['message'])
        setIsLoading(false)
        setShowResponseMessage(true)
    }

    const updateStatus = (e) => {
        setIsLoading(true)
        setShowOptions(false)
        setShowResponseMessage(false)
        const options = {}
        const reqData = { 'action': e, 'request_id': props.requestId }
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => setResponse(res))
            .catch(err => console.log(err))
    }

    return (
        <Fragment>
            {showOptions && (
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                    <div className="px-4 sm:px-6 py-4 border-b border-neutral-200">
                        <h2 className="text-lg font-semibold text-neutral-800">Please select the status to set:</h2>
                        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
                    </div>
                    <div className="p-4 sm:p-6 flex flex-wrap gap-3">
                        <button
                            className="bg-red-100 hover:bg-red-200 text-red-700 font-medium py-2 px-4 rounded-lg border border-red-300 transition-colors"
                            onClick={() => updateStatus('setCanceled')}
                        >
                            Set to Canceled
                        </button>
                        <button
                            className="bg-blue-100 hover:bg-blue-200 text-blue-700 font-medium py-2 px-4 rounded-lg border border-blue-300 transition-colors"
                            onClick={() => updateStatus('setOpen')}
                        >
                            Set to Open
                        </button>
                        <button
                            className="bg-amber-100 hover:bg-amber-200 text-amber-700 font-medium py-2 px-4 rounded-lg border border-amber-300 transition-colors"
                            onClick={() => updateStatus('setOnHold')}
                        >
                            Set to On Hold
                        </button>
                        <button
                            className="bg-green-100 hover:bg-green-200 text-green-700 font-medium py-2 px-4 rounded-lg border border-green-300 transition-colors"
                            onClick={() => updateStatus('setScheduled')}
                        >
                            Set to Scheduled
                        </button>
                    </div>
                </div>
            )}
            {isLoading && (
                <div className="flex justify-center my-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                </div>
            )}
            {showResponseMessage && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mt-4">
                    {responseMessage}
                </div>
            )}
        </Fragment>
    );
};

export default AdminEditStatus;
